import { Container } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { IntegrationDetail } from '../components/Integrations';
import { Footer } from '../components/Layout/Footer';

export function IntegrationDetailPage() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <>
      <Container size="lg" py="xl">
        <IntegrationDetail slug={slug ?? ''} />
      </Container>
      <Footer />
    </>
  );
}
